import classNames from 'classnames';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button, Label, Icon } from '../..';
const Default = _ref => {
  let {
    description,
    handleClose,
    handleOnClick,
    iconName,
    image,
    imageDimensions,
    imagePosition,
    label,
    labelClassName,
    labelColor,
    loading,
    primaryBtnTitle,
    secondaryBtnTitle,
    primaryBtnColor,
    title,
    primaryBtnLabel,
    primaryBtnLabelColor
  } = _ref;
  const {
    width: imageWidth,
    height: imageHeight
  } = imageDimensions || {};
  return /*#__PURE__*/React.createElement(React.Fragment, null, iconName && /*#__PURE__*/React.createElement("span", {
    className: classNames('icon hide-xs banner-icon', iconName)
  }), image && /*#__PURE__*/React.createElement("img", {
    className: classNames('image hide-xs', imagePosition),
    src: image,
    alt: "missingStatement",
    width: imageWidth || '128px',
    height: imageHeight || '128px'
  }), /*#__PURE__*/React.createElement("div", {
    className: "info-section"
  }, title && /*#__PURE__*/React.createElement("p", {
    className: "title"
  }, title, label && /*#__PURE__*/React.createElement(Label, {
    title: label,
    className: labelClassName,
    color: labelColor
  })), description && /*#__PURE__*/React.createElement("p", {
    className: "desc"
  }, description)), /*#__PURE__*/React.createElement("div", {
    className: "btn-container"
  }, handleOnClick && /*#__PURE__*/React.createElement(Button, {
    type: "flat",
    title: primaryBtnTitle,
    onClick: handleOnClick,
    loading: loading,
    color: primaryBtnColor || 'white',
    label: primaryBtnLabel,
    labelColor: primaryBtnLabelColor
  }), handleClose && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    className: "close hide show-xs",
    type: "link",
    title: secondaryBtnTitle,
    onClick: handleClose
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    className: "hide-xs",
    onClick: handleClose
  }))));
};
Default.propTypes = {
  description: PropTypes.string,
  handleClose: PropTypes.func,
  handleOnClick: PropTypes.func,
  iconName: PropTypes.string,
  image: PropTypes.string,
  imageDimensions: PropTypes.object,
  imagePosition: PropTypes.string,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  labelColor: PropTypes.string,
  loading: PropTypes.bool,
  primaryBtnTitle: PropTypes.string,
  secondaryBtnTitle: PropTypes.string,
  title: PropTypes.string,
  primaryBtnColor: PropTypes.string,
  primaryBtnLabel: PropTypes.string,
  primaryBtnLabelColor: PropTypes.string
};
export default /*#__PURE__*/memo(Default);